import React from 'react';
import './ChoiceButton.scss';

const ChoiceButton = ({
  active = false,
  choiceLabel = 'A',
  choiceText = 'ตัวอย่างคำตอบ',
  width = undefined,
  onClick = () => { },
  colorScheme = {}
}) => {
  const {
    bgColor,
    labelShadowColor,
    labelDropShadowColor,
    textColor,
    activeGradientStart,
    activeGradientEnd,
    activeBorderGradientStart,
    activeBorderGradientEnd,
    activeBoxShadowColor,
    activeLabelInnerBg,
  } = colorScheme;

  const cssVars = {
    ...(bgColor && { '--cb-bg-color': bgColor }),
    ...(labelShadowColor && { '--cb-label-shadow-color': labelShadowColor }),
    ...(labelDropShadowColor && { '--cb-label-drop-shadow-color': labelDropShadowColor }),
    ...(textColor && { '--cb-text-color': textColor }),
    ...(activeGradientStart && { '--cb-active-gradient-start': activeGradientStart }),
    ...(activeGradientEnd && { '--cb-active-gradient-end': activeGradientEnd }),
    ...(activeBorderGradientStart && { '--cb-active-border-gradient-start': activeBorderGradientStart }),
    ...(activeBorderGradientEnd && { '--cb-active-border-gradient-end': activeBorderGradientEnd }),
    ...(activeBoxShadowColor && { '--cb-active-box-shadow-color': activeBoxShadowColor }),
    ...(activeLabelInnerBg && { '--cb-active-label-inner-bg': activeLabelInnerBg }),
    ...(width && { width }),
  };

  return (
    <div
      className={`choice-button-container${active ? ' choice-button-active' : ''}`}
      onClick={onClick}
      style={cssVars}
    >
      <div className="choice-button-label">
        <div className="choice-button-label-inner">
          <div className="choice-button-label-text">{choiceLabel}</div>
        </div>
      </div>
      <div className="choice-button-text">{choiceText}</div>
    </div>
  );
};

export default ChoiceButton;
